import { type CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

export const csvButtonCss: CSSObject = {
  color: constants.colors.ui.neutral[700],
  ...typographyStyles.textMObj,
  fontWeight: "100",

  // Styles for the loading spinner
  "div[role=img]": {
    margin: "unset",
    width: "unset",
    height: "unset",
    display: "flex",
    alignContent: "center",

    svg: {
      width: "16px",
      height: "16px",
    },
  },
};
